import { MESSAGES } from './ProfileClickEgg';

export const ACHIEVEMENTS = {
    AVATAR_LEGEND: {
        id: 'AVATAR_LEGEND',
        title: 'We have clicked!',
        description: `Click on me ${MESSAGES.length} times.`,
    },
    IDLE_WATCHER: {
        id: 'IDLE_WATCHER',
        title: 'Still here?',
        description: 'Stay on the page for 1 minute.',
    },
    LINK_EXPLORER: {
        id: 'LINK_EXPLORER',
        title: 'Thanks for the interest!',
        description: 'Click one of the "fact" links.',
    },
    GAME_CLICKER: {
        id: 'GAME_CLICKER',
        title: 'Playful visitor',
        description: 'Click on a game or talk. Hope you had fun :P',
    },
    CONTACT_CLICKER: {
        id: 'CONTACT_CLICKER',
        title: 'Nice to meet you!',
        description: 'Click on a contact link.', 
    },
    ARROW_CLICKER: {
        id: 'ARROW_CLICKER',
        title: 'Carousel enjoyer',
        description: 'Move through the carousel.',
    },
    CAROUSEL_TRAVELER: {
        id: 'CAROUSEL_TRAVELER',
        title: 'Willy Fog',
        description: 'Browse through the full carousel.',
    },
    ABOUT_VISITOR: {
        id: 'ABOUT_VISITOR',
        title: "It's getting personal",
        description: 'Visit the About section.',
    },
    DOG_CLICKER: {
        id: 'DOG_CLICKER',
        title: 'Who\'s a good boy?',
        description: 'Click on Pico the Dog.',
    },
    COMPLETIONIST: {
        id: 'COMPLETIONIST',
        title: 'Platinum websurfer',
        description: 'Unlock every achievement. If you had fun, imagine just playing one of my games! :)',
    },
};
